const Footer = () => {
    return ( 
        <footer>
           <div class="footerLogo_container">
            <h2>NRG <span>Movieroom</span></h2>
            <p>Company</p>
            <p>Contact The Dev @</p>
            <div class="socialLinks">
                <a href="https://linkedin.com/in/emmanuel-omolaju-747708248"><i class="bi bi-linkedin"></i></a>
                <a href="https://www.twitter.com/nrg_build"><i class="bi bi-twitter"></i></a>
                <a href="https://github.com/NRG-BUILDS/"><i class="bi bi-github"></i></a>
            </div>
      </div>
      <div class="credits">
          <p>Built with ❤️ from <a href="https://www.nrg.netlify.app">NRG</a></p>
          <p>Inspired by designs from 🌟 from <a href="https://www.twitter.com/ojo__chide">@ojo_chide</a></p>
          <p><a href="https://developers.themoviedb.org/3/">⚡ by tmdb API</a></p>
      </div> 
        </footer>
     );
}
 
export default Footer;